(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = window.themeMoneyFormat || '${{amount}}';
  function money(cents) {
    var v = cents / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      var n = k.indexOf('no_decimals') > -1
        ? Math.round(v).toLocaleString('en-US')
        : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (k.indexOf('comma') > -1) n = n.replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.');
      return n;
    });
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 2000);
  }

  /* ---------- Bag drawer ---------- */
  var drawer = $('#cart-drawer'), scrim = $('#scrim');
  function openCart(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    scrim.hidden = !open;
    if (open) { renderCart(); $('#cart-close').focus(); }
  }
  function imgUrl(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function renderCart(cart) {
    var p = cart ? Promise.resolve(cart) : fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return p.then(function (c) {
      $$('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
      var items = $('#cart-items'), foot = $('#cart-foot');
      if (!items) return;
      if (!c.item_count) {
        items.innerHTML = '<div class="empty"><p>Your bag is empty. Every butterfly starts somewhere.</p></div>';
        foot.innerHTML = '<a class="btn btn-primary" href="' + root + 'collections/all">Browse the shop</a>';
        return;
      }
      items.innerHTML = c.items.map(function (i, idx) {
        var variant = i.product_has_only_default_variant ? '' : (i.variant_title || '');
        return '<div class="item"><div class="thumb">' + (i.image ? '<img src="' + esc(imgUrl(i.image, 160)) + '" alt="">' : '') + '</div>' +
          '<div class="meta"><a href="' + esc(i.url) + '"><b>' + esc(i.product_title) + '</b></a><span>' + esc(variant) + '</span>' +
          '<div class="qty"><button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity - 1) + '" aria-label="Decrease">−</button><output>' + i.quantity + '</output>' +
          '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
          '<div class="lp">' + money(i.final_line_price) + '</div></div>';
      }).join('');
      foot.innerHTML = '<div class="sum total"><span>Subtotal</span><span>' + money(c.total_price) + '</span></div>' +
        '<p class="note">' + esc(drawer.dataset.note || 'Shipping and taxes are calculated at checkout.') + '</p>' +
        '<form action="' + root + 'cart" method="post"><button class="btn btn-primary" type="submit" name="checkout">Check out</button></form>';
    });
  }
  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]') || !drawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || 'That item could not be added.'); return; }
        toast((res.j.product_title || 'Item') + ' added');
        openCart(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('button, a'); if (!t) return;
    if (t.matches('[data-open-cart]') && drawer) { e.preventDefault(); openCart(true); }
    else if (t.id === 'cart-close') { openCart(false); }
    else if (t.dataset.line) { changeLine(+t.dataset.line, Math.max(0, +t.dataset.qty)); }
    else if (t.dataset.filter) {
      var f = t.dataset.filter;
      $$('[data-filter]').forEach(function (c) { c.setAttribute('aria-pressed', String(c === t)); });
      $$('[data-coll]').forEach(function (s) { s.hidden = f !== 'all' && s.dataset.coll !== f; });
    }
    else if (t.classList.contains('th')) {
      var r = t.closest('[data-product-root]') || document, img = $('[data-main-img]', r);
      if (img) { img.removeAttribute('srcset'); img.src = t.dataset.src; }
      $$('.th', r).forEach(function (b) { b.setAttribute('aria-pressed', String(b === t)); });
    }
    else if (t.classList.contains('pill')) { pickOption(t); }
  });
  if (scrim) scrim.addEventListener('click', function () { openCart(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openCart(false); });

  /* ---------- Variant pickers ---------- */
  function pickOption(btn) {
    var box = btn.closest('[data-buy]'); if (!box) return;
    var groups = $$('.pills', box);
    var gi = groups.indexOf(btn.closest('.pills'));
    syncBuy(box, gi, btn.dataset.value);
  }
  function syncBuy(box, gi, val) {
    var el = $('script[data-variants]', box); if (!el) return;
    var variants = JSON.parse(el.textContent);
    var groups = $$('.pills', box);
    if (!groups.length) return;
    var sel = groups.map(function (g) { var p = $('.pill[aria-pressed="true"]', g); return p ? p.dataset.value : null; });
    if (gi > -1) sel[gi] = val;
    /* exact match, otherwise the closest variant that keeps the value just clicked */
    var pool = gi > -1 ? variants.filter(function (x) { return x.options[gi] === val; }) : variants;
    var best = null, bestScore = -1;
    pool.forEach(function (x) {
      var score = 0;
      x.options.forEach(function (o, i) { if (o === sel[i]) score += (i < (gi > -1 ? gi : 99) ? 4 : 2); });
      if (x.available) score += 1;
      if (score > bestScore) { best = x; bestScore = score; }
    });
    var v = best;
    if (v) sel = v.options.slice();
    groups.forEach(function (g, i) {
      $$('.pill', g).forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.value === sel[i]));
        var possible = variants.some(function (x) {
          if (x.options[i] !== b.dataset.value) return false;
          for (var k = 0; k < i; k++) if (x.options[k] !== sel[k]) return false;
          return true;
        });
        b.hidden = !possible;
      });
      var grp = g.closest('.opt-group');
      if (grp) grp.hidden = $$('.pill', g).filter(function (b) { return !b.hidden; }).length < 2 && g.querySelectorAll('.pill').length > 1 && $('.pill:not([hidden])', g) && $('.pill:not([hidden])', g).dataset.value === '-';
    });
    var add = $('[data-add-btn]', box), price = $('[data-price]', box), input = $('[data-variant-id]', box);
    if (!v) { if (add) { add.disabled = true; add.textContent = 'Unavailable'; } return; }
    if (input) input.value = v.id;
    if (price) price.textContent = money(v.price);
    if (add) { add.disabled = !v.available; add.textContent = v.available ? 'Add to bag' : 'Sold out'; }
    var r = box.closest('[data-product-root]');
    if (r && gi > -1) {
      if (v.featured_image) { var img = $('[data-main-img]', r); if (img) { img.removeAttribute('srcset'); img.src = imgUrl(v.featured_image.src, 1100); } }
      if (window.history.replaceState && r.hasAttribute('data-update-url')) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
  }
  $$('[data-buy]').forEach(function (b) { syncBuy(b, -1, null); });
})();

/* Typeform quiz pop-up: any link to a typeform.com address opens in an on-site window */
(function () {
  var modal, frame, title, openLink, lastFocus;
  function build() {
    modal = document.createElement('div');
    modal.className = 'qz-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.hidden = true;
    modal.innerHTML = '<div class="qz-backdrop" data-qz-close></div>' +
      '<div class="qz-box"><div class="qz-bar"><span class="qz-title"></span>' +
      '<a class="qz-newtab" target="_blank" rel="noopener">Open in new tab ↗</a>' +
      '<button type="button" class="qz-x" data-qz-close aria-label="Close quiz">×</button></div>' +
      '<iframe class="qz-frame" title="Quiz" allow="camera; microphone; autoplay; encrypted-media; fullscreen; clipboard-write"></iframe></div>';
    document.body.appendChild(modal);
    frame = modal.querySelector('.qz-frame');
    title = modal.querySelector('.qz-title');
    openLink = modal.querySelector('.qz-newtab');
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-qz-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }
  function open(url, name) {
    if (!modal) build();
    lastFocus = document.activeElement;
    title.textContent = name || 'Quiz';
    openLink.href = url;
    frame.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'typeform-embed=popup-blank&typeform-source=' + encodeURIComponent(location.hostname);
    modal.hidden = false;
    document.documentElement.classList.add('qz-lock');
    modal.querySelector('.qz-x').focus();
  }
  function close() {
    modal.hidden = true;
    frame.src = 'about:blank';
    document.documentElement.classList.remove('qz-lock');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="typeform.com"]');
    if (!a || a.hasAttribute('data-qz-skip') || a.closest('.qz-modal')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    if (window.innerWidth < 360) return;
    e.preventDefault();
    open(a.href, a.getAttribute('data-quiz-title') || a.textContent.trim());
  });
})();
